<template>
   <div class="seat-map-generator-container">
      <div class="seat-map-generator" id="seat-map-identifer">
         <template v-for="(row, rowIndex) in map">
            <SeatRow :currency="currency" :row="row" :key="rowIndex" />
         </template>
      </div>
      <div class="seat-map-navigator" v-if="false">
         <div id="navigator">
            <!-- Navigator box -->
            <div id="nav-indicator"></div>
         </div>
      </div>
   </div>
</template>

<script>
import SeatRow from "@/components/structural/flight/order-detail/ancillaries/seatmap2/SeatRow.vue";

export default {
   name: "SeatmapGenerator",
   components: {
      SeatRow,
   },
   props: {
      currency: String,
      map: Array,
   },

   mounted() {
      // document.querySelector(".seat-map-generator-container").addEventListener("scroll", function () {
      //    var container = this;
      //    var totalHeight = container.scrollHeight;
      //    var visibleHeight = container.clientHeight;
      //    var scrollPosition = container.scrollTop;
      //    var navHeight = document.getElementById("navigator").clientHeight;
      //    var indicator = document.getElementById("nav-indicator");
      //    var indicatorHeight = (visibleHeight / totalHeight) * navHeight;
      //    // indicator.style.height = indicatorHeight + "px";
      //    var indicatorPosition = (scrollPosition / totalHeight) * navHeight;
      //    indicator.style.top = indicatorPosition + "px";
      // });
   },
};
</script>

<style lang="scss" scoped>
.seat-map-generator-container {
   display: flex;
   justify-content: center;
   align-items: flex-start;

   width: 100%;
   padding: 0rem;

   height: 550px;
   overflow: auto;
   position: relative;

   @media only screen and (max-width: 768px) {
      height: 450px;
      transform-origin: top;
      transform: scale(0.9);
   }

   .seat-map-generator {
      //background-color: var(--gray-50);
      background-color: var(--gray-0);
      padding: 1rem;
      border-radius: 1rem;
      border: 5px solid var(--gray-100);
      /* box-shadow: inset 0px 0px 30px var(--blue-800-alpha-75); */
      box-shadow: var(--gts-box-shadow);
      width: fit-content;
   }

   .row {
      margin-bottom: 1rem;
      border-bottom: 1px solid;
   }

   .seat-map-navigator {
      position: sticky;
      top: 10px;
      right: 10px;
      height: 120px;
      width: 100px;
      //background-color: var(--gray-50);
      background-color: var(--gray-0);
      border: 3px solid var(--gray-200);
      /* box-shadow: 0 2px 5px var(--gray-1000-alpha-75); */
      box-shadow: var(--gts-box-shadow);
      z-index: 10;
   }

   #nav-indicator {
      width: 100%;
      height: 60px;
      border: 2px solid var(--accent-primary);
      background: var(--accent-primary-alpha-25);
      position: relative;
   }
}

.tooltip {
   position: absolute;
   z-index: 1000;
   background-color: var(--gray-1000-alpha-25);
   //color: var(--gray-50);
   color: var(--gray-0);
   padding: 0.5rem;
   border-radius: 0.25rem;
   /* box-shadow: 0 2px 5px var(--gray-1000-alpha-75); */
   box-shadow: var(--gts-box-shadow);
}

.deneme {
   position: sticky;
   top: 0;
}
</style>
